import React, { act, useEffect, useState } from "react";
import { useAuth } from "../../../auth/FirebaseAuth.js";

import {
  createDoc,
  deleteDocById,
  getFlutterTime,
  getFlutterTimeFromSeconds,
  getLocalStringFromFlutter,
  getRefFromId,
  queryCollection,
} from "../../../models/DataFunctions.js";
import SecondaryButton from "../../../buttons/SecondaryButton.js";

import { useAppContext } from "../../../config/AppContext.js";

import { useSnackbar } from "notistack";

import TextField2T from "../../../textfields/TextField2T.js";
import PrimaryButton from "../../../buttons/PrimaryButton.js";

import SmallSpinner from "../../../loading/SmallSpinner.js";
import NavBarButton from "../../../buttons/NavBarButton.js";
import { BlockNumer } from "../../home/MasterSmallStats.js";
import Icon1 from "../../../icons/Icon.js";
import TextFieldEmail from "../../../textfields/TextFieldEmail.js";
import DataGridGPT2 from "../../../tables/DataGridGPT2.js";
import { dbHexamails } from "../../../config/FirebaseConfig.js";
import { getDoc, updateDoc } from "firebase/firestore";
import Modal1 from "../../../modals/Modal1.js";
import { email_base } from "./hexamails_data.js";
import TabGPT from "../../../tabs/TabGPT.js";
import { HM_NavBar } from "./HM_NavBar.js";
import { CampaignPage } from "./CampaignPage.js";
import { EmailTemplatePage } from "./EmailTemplatePage.js";
import { transformEmailDeliveredToTable } from "../../../models/OrgFunctions.js";
import EmailKPIS from "./EmailKPIS.js";
function Hexamails({ navigateWorkspace }) {
  const { currentUser, loading } = useAuth();

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const [userData, setUserData] = useState(null);
  const [tab, setTab] = useState("kpis");
  const [email_selected, setEmailSelected] = useState(null);
  const [campaign_selected, setCampaignSelected] = useState(null);
  const [active_campaign_selected, setActiveCampaignSelected] = useState(null);
  const [choose_email_for_campaign, setChooseEmailForCampaigns] =
    useState(false);
  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);
  const [email_templates, setEmailTempaltes] = useState([]);
  const [campaigns, setCampaigns] = useState([]);
  const [active_campaigns, setActiveCampaigns] = useState([]);
  const [choose_user_open, setChooseUserOpen] = useState(false);
  const [masters, setMasters] = useState([]);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const [tab_campaign, setTabCampaign] = useState("campaign");
  const [emails_delivered, setEmailsDelivered] = useState([]);
  const [history_tab, setHistoryTab] = useState("campaign");
  const [history_searchvalue, setHistorySearchValue] = useState("");
  const handleFetchData = async () => {
    let email_templates = await queryCollection(
      "email_template",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    let campagins = await queryCollection(
      "campaign",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    let active_campagins = await queryCollection(
      "active_campaign",
      [],
      100,
      null,
      null,
      dbHexamails
    );
    setEmailTempaltes(email_templates);
    setActiveCampaigns(active_campagins);
    setCampaigns(campagins);
  };
  const [email_delivered_open, setEmailDeliveredOpen] = useState(false);

  const handleOpenEmail = (email) => {
    console.log("open email", email);
    let matching_email = emails_delivered.find((e) => e.id === email.id);
    if (matching_email) {
      // open html_content in new tab
      console.log("matching_email", matching_email);
      setEmailDeliveredOpen(matching_email);
    }
  };

  const handleFetchEmailDelivered = async () => {
    let emails_delivered = await queryCollection(
      "email_delivered",
      [],
      1000,
      null,
      null,
      dbHexamails
    );
    setEmailsDelivered(emails_delivered);
  };

  const [loadingData, setLoadingData] = useState(false);

  // Fetch data when the component mounts or when currentUser changes
  useEffect(() => {
    setCampaignSelected(null);
    setEmailSelected(null);
    handleFetchData();

    if (tab === "history") {
      handleFetchEmailDelivered();
    }
  }, [tab]);

  useEffect(() => {
    const { rows, columns } = transformEmailDeliveredToTable(
      emails_delivered,
      history_tab,
      history_searchvalue
    );
    setRows(rows);
    setColumns(columns);
  }, [emails_delivered, history_tab, history_searchvalue]);

  // If the data is still loading or the user is not authenticated, show a loading message
  if (loading || !currentUser) {
    return <SmallSpinner></SmallSpinner>;
  }

  // Render the client data
  return (
    <div className="flex flex-row h-full w-full p-4  overflow-auto ">
      <div className="h-fit pb-40 flex flex-row gap-4">
        <HM_NavBar tab={tab} setTab={setTab}></HM_NavBar>
        <div className="flex flex-col  flex-grow  gap-1 ">
          <div className="text-h3">Hexamails</div>
          <div className=" text-h1 font-bold">
            {tab === "kpis"
              ? "KPIs des clics des emails"
              : tab === "campaigns"
                ? "Campagnes de onboarding"
                : tab === "history"
                  ? "Historique des emails envoyés"
                  : tab === "emails"
                    ? "Emails templates"
                    : tab === "bulks"
                      ? "Bulks emails"
                      : ""}
          </div>
          {tab === "kpis" && <EmailKPIS></EmailKPIS>}
          {tab === "history" && (
            <div className="flex flex-col gap-2 mt-4 max-w-c1p2k">
              <TabGPT
                tabs={[
                  { id: "campaign", label: "Campagnes" },
                  { id: "event", label: "Evénements" },
                ]}
                activeTab={history_tab}
                setActiveTab={setHistoryTab}
              ></TabGPT>
              <DataGridGPT2
                initial_sort_field="sent_at"
                initial_asc="desc"
                rows={rows}
                columns={columns}
                onClick={handleOpenEmail}
              ></DataGridGPT2>
              <Modal1
                isOpen={email_delivered_open !== false}
                onClose={() => setEmailDeliveredOpen(false)}
              >
                <div className="bg-white p-4 rounded-lg overflow-auto border-b h-[80%] w-[60%] flex flex-row ">
                  <div
                    className="prose max-w-none " // optional: Tailwind style for readable HTML
                    dangerouslySetInnerHTML={{
                      __html: email_delivered_open.html_content || "",
                    }}
                  />
                </div>
              </Modal1>
            </div>
          )}
          {tab === "campaigns" && (
            <div className="flex flex-col gap-1 mt-4">
              <CampaignPage></CampaignPage>
            </div>
          )}
          {tab === "emails" && <EmailTemplatePage></EmailTemplatePage>}

          {tab === "bulks" && (
            <div className="flex flex-col gap-1 mt-4">
              <PrimaryButtonHexamails
                startIcon={
                  <Icon1 icon_name="plus" width="18px" fill="white"></Icon1>
                }
                className="mb-4"
              >
                Nouveau bulk email
              </PrimaryButtonHexamails>
              <BlockCampaign
                title="Mises à jour d'octobre (Agenda Google & Planning)"
                number="1245"
                icon="send"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export const PrimaryButtonHexamails = ({
  onClick = () => {},
  children,
  startIcon,
  className = "",
}) => {
  return (
    <PrimaryButton
      className={`bg-indigo-500 w-fit ${className}`}
      big={true}
      onClick={onClick}
      startIcon={startIcon}
    >
      {children}
    </PrimaryButton>
  );
};

export default Hexamails;
export const BlockCampaign = ({
  title,
  number = null,
  icon = "folder",
  fill = "black",
  textclassname = "",
  sufix = "",
  onClick = () => {},
  shadow_color = "shadow-indigo-100",
}) => {
  return (
    <div
      onClick={onClick}
      className={`bg-white  border-l-3 border-indigo-500 duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-4 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c500   border-blue-100`}
    >
      <Icon1 icon_name={icon} size={18} fill={fill}></Icon1>
      <div className=" text-h3 flex flex-row   ">{title}</div>
      <div className=" text-h3 flex flex-row font-bold ml-auto text-indigo-500  ">
        {number}
      </div>
    </div>
  );
};

export const BlockEmailTemplate = ({
  title,
  number_1 = 0,
  number_2 = 0,
  number_3 = 0,
  icon = "folder",
  fill = "black",
  textclassname = "",
  sufix = "",
  onClick = () => {},
  shadow_color = "shadow-indigo-100",
  border_color = "border-indigo-500",
}) => {
  return (
    <div
      onClick={onClick}
      className={`bg-white  border-l-3 ${border_color}  duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-4 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c500   border-blue-100`}
    >
      <Icon1 icon_name={icon} size={18} fill={fill}></Icon1>
      <div className=" text-h3 flex flex-row   ">{title}</div>
      <div
        className={`  ${number_1 && number_1 > 0 ? "text-indigo-500" : "text-gray-200"}
         text-h3 flex flex-row font-bold ml-auto   `}
      >
        {number_1 || "0"}
      </div>{" "}
      <div
        className={`  ${number_2 && number_2 > 0 ? "text-indigo-500" : "text-gray-200"}
         text-h3 flex flex-row font-bold    `}
      >
        {number_2 || "0"}
        {sufix}
      </div>
      <div
        className={`  ${number_3 ? (number_3 > 0 ? "text-green-500" : "text-gray-200") : "hidden"}
         text-h3 flex flex-row font-bold    `}
      >
        {number_3 || "0"}
        {sufix}
      </div>
    </div>
  );
};

export const BlockStep = ({
  title,
  delay,
  step = null,
  trigger_date = null,
  icon_name = "send",
  email_template_id = "",
  number = null,
  icon = "folder",
  fill = "black",
  textclassname = "",
  sufix = "",
  onClick = () => {},
  onClickDelete = () => {},
  onClickUp = () => {},
  onClickDown = () => {},
  shadow_color = "shadow-indigo-100",
}) => {
  return (
    <div className="flex flex-row gap-1">
      <div
        onClick={onClick}
        className={`
          ${step.state === "sent" ? " border-lime-300 bg-lime-50" : step.state === "clicked" ? "border-green-500 bg-green-50" : "border-indigo-500 bg-white"}
            border-l-3  duration-300 transition-all  rounded-xl  hover:translate-x-2 cursor-pointer hover:shadow-lg   p-4 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c500   border-blue-100`}
      >
        <Icon1 icon_name={icon_name} size={18} fill={fill}></Icon1>
        <div className=" text-h3 flex flex-row   ">
          <div className="flex flex-col gap-1">
            <>{title} </>
            {email_template_id && (
              <div className="text-h5 text-neutral-300">
                {email_template_id + " " + step.state}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col ml-auto gap-1">
          {step.state === "pending" ? (
            <>
              <div className=" text-h3 flex flex-row  text-indigo-500 gap-2 ">
                wait {delay} days{" "}
                <Icon1 icon_name={"horloge"} size={18} fill={"#6366f1"}></Icon1>
              </div>
              <div className=" text-h3 flex flex-row   text-indigo-500 gap-2 ">
                {trigger_date}
                <Icon1 icon_name={"date"} size={18} fill={"#6366f1"}></Icon1>
              </div>
            </>
          ) : (
            <>
              {step.sent_at && (
                <div className=" text-h3 flex flex-row   text-gray-300 gap-2 ">
                  {getLocalStringFromFlutter(step.sent_at)}
                  <Icon1
                    icon_name={"date"}
                    size={18}
                    fill={"lightgrey"}
                  ></Icon1>
                </div>
              )}
            </>
          )}
        </div>
      </div>
      {step.state === "sent" || step.state === "clicked" ? (
        <></>
      ) : (
        <>
          <div className="flex flex-col gap-1">
            <div
              onClick={onClickUp}
              className={`bg-white  justify-center duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-2 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c50   border-blue-100`}
            >
              <Icon1 icon_name={"up"} size={18} fill={"#6366f1"}></Icon1>
            </div>{" "}
            <div
              onClick={onClickDown}
              className={`bg-white justify-center duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-2 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c50   border-blue-100`}
            >
              <Icon1 icon_name={"down"} size={18} fill={"#6366f1"}></Icon1>
            </div>
          </div>
          <div
            onClick={onClickDelete}
            className={`bg-white   duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-4 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c50   border-blue-100`}
          >
            <Icon1 icon_name={"delete"} size={18} fill={"#6366f1"}></Icon1>
          </div>
        </>
      )}
    </div>
  );
};

export const BlockStepCampaign = ({
  title,
  delay,
  step = null,
  trigger_date = null,
  icon_name = "send",
  email_template_id = "",
  number = null,
  icon = "folder",
  fill = "black",
  textclassname = "",
  sufix = "",
  onClick = () => {},
  onClickDelete = () => {},
  onClickUp = () => {},
  onClickDown = () => {},
  shadow_color = "shadow-indigo-100",
}) => {
  return (
    <div className="flex flex-row gap-1">
      <div
        onClick={onClick}
        className={`
          ${step.state === "sent" || step.state === "clicked" ? " border-green-500 bg-green-50" : "border-indigo-500 bg-white"}
            border-l-3  duration-300 transition-all  rounded-xl  hover:translate-x-2 cursor-pointer hover:shadow-lg   p-4 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c500   border-blue-100`}
      >
        <Icon1 icon_name={icon_name} size={18} fill={fill}></Icon1>
        <div className=" text-h3 flex flex-row   ">
          <div className="flex flex-col gap-1">
            <>{title} </>
            {email_template_id && (
              <div className="text-h5 text-neutral-300">
                {email_template_id + " " + step.state}
              </div>
            )}
          </div>
        </div>
        <div className="flex flex-col ml-auto gap-1">
          <>
            <div className=" text-h3 flex flex-row  text-indigo-500 gap-2 ">
              {delay} jours{" "}
              <Icon1 icon_name={"horloge"} size={18} fill={"#6366f1"}></Icon1>
            </div>
          </>
        </div>
      </div>
      {step.state === "sent" || step.state === "clicked" ? (
        <></>
      ) : (
        <>
          <div className="flex flex-col gap-1">
            <div
              onClick={onClickUp}
              className={`bg-white  justify-center duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-2 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c50   border-blue-100`}
            >
              <Icon1 icon_name={"up"} size={18} fill={"#6366f1"}></Icon1>
            </div>{" "}
            <div
              onClick={onClickDown}
              className={`bg-white justify-center duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-2 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c50   border-blue-100`}
            >
              <Icon1 icon_name={"down"} size={18} fill={"#6366f1"}></Icon1>
            </div>
          </div>
          <div
            onClick={onClickDelete}
            className={`bg-white   duration-300 transition-all hover:translate-x-2 rounded-xl cursor-pointer  hover:shadow-lg  p-4 flex flex-row gap-4 items-center shadow-md ${shadow_color} hover:${shadow_color} w-c50   border-blue-100`}
          >
            <Icon1 icon_name={"delete"} size={18} fill={"#6366f1"}></Icon1>
          </div>
        </>
      )}
    </div>
  );
};

export const updateDocHM = async (collection, id, data) => {
  // remove id and ref fields from data
  let new_data = { ...data };
  delete new_data.id;
  delete new_data.ref;
  let ref = getRefFromId(collection, id, dbHexamails);

  let res = await updateDoc(ref, new_data);
  return res;
};
export const createDocHM = async (collection, data) => {
  let res = await createDoc(collection, data, dbHexamails);
  return res;
};

export const getDocHm = async (collection, id) => {
  let ref = getRefFromId(collection, id, dbHexamails);
  let res = await getDoc(ref);
  return res;
};

export const deleteDocHM = async (collection, id) => {
  await deleteDocById(collection, id, dbHexamails);
};
